<script>
import CommonTableComponent from "@/components/table.vue";

export default {
  components: {CommonTableComponent},
  props: {
    transportContract: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    removeContract() {
      this.$emit("removeContract");
    },
  },
}
</script>

<template>
  <CommonTableComponent :height-class="`table-wrapper-300`">
    <thead class="table-light">
    <tr>
      <th style="width: 30%">CA管理番号</th>
      <th style="width: 60%">収集運搬契約名</th>
      <th v-if="!disabled"></th>
    </tr>
    </thead>
    <tbody>
    <tr v-if="transportContract">
      <td>{{transportContract.transport_contract_cd}}</td>
      <td>{{transportContract.transport_contract_name}}</td>
      <td v-if="!disabled" class="text-center">
        <b-button class="btn-custom-red" @click="removeContract"><i class="fas fa-eraser"></i> 削除</b-button>
      </td>
    </tr>
    </tbody>
  </CommonTableComponent>
</template>
